import React, { useState, useEffect, useCallback, useContext } from "react";
import axios from "axios";
import styled from "styled-components";
import { NotificationManager } from "react-notifications";
import _ from "lodash";
import InsertEmoticonIcon from "@mui/icons-material/InsertEmoticon";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import { ActionContext } from "context/ActionContext";
import { ActionPlansContext } from "context/ActionPlansContext";
import UserService from "services/UserService";
import {
  putAction,
  getAction,
  getSite,
  postActionImpact,
} from "services/ConfigServices";
import { action as actionVar } from "variables/action";
import {
  energyType,
  unityTypeData,
  unitycountTypeData,
  unitcostData,
  targetedenergyList,
  targetedusageList,
  savingstypeData,
  savingscalculationData,
} from "variables/lists/action";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import {
  MultiselectCheckbox,
  CustomSelect,
  IntInput,
  FloatInput,
} from "components/Input/Index.js";
//import NavPills from "components/NavPills/NavPills.js";
import EditButton from "components/CustomButtons/EditButton";
import ButtonGroups from "components/Ui/Buttons/ButtonGroups";
import RTTargetFluid from "./Fluid/RTTargetFluid";
import RTEquipments from "./Equipments/RTEquipments";
import RTExpertSavings from "./Savings/Expert/RTExpertSavings";
import RTSimpleSavings from "./Savings/Simple/RTSimpleSavings";

const SubTitle = styled.div`
  margin: ${(props) =>
    props.first ? "1rem 0rem 0.1rem 1.4rem" : "1.4rem 0rem 0.1rem 1.4rem"};
  font-size: 1.2rem;
  font-weight: 500;
  text-underline-position: under;
  text-decoration: underline;
  text-decoration-color: #91c73c;
`;

const RecommendationArea = styled.div`
font-size: 14px;
font-weight: 500;
font-family: "Source Sans Pro",sans-serif;
border: 0.099rem solid rgba(0, 0, 0, 0.22);
border-radius: 0.3rem;
padding: 7px;
margin-left: -15px;
`;

export default function EquipmentsSystem({ apiData, params, closeModal }) {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const actionplanupdate = permis.includes("actionplan_update");
  const appContext = useContext(ActionContext);
  const { action, setAction } = appContext;
  const plansContext = useContext(ActionPlansContext);
  const { actionPlans, setActionPlans } = plansContext;

  const [newImpact, setNewImpact] = useState({});
  const [newReference, setNewReference] = useState();
  const [patrimoineData, setPatrimoineData] = useState([]);
  const [tertiaryBillData, setTertiaryBillData] = useState({});
  const [unitQuantityValue, setUnitQuantityValue] = useState("");
  const [unitCostValue, setUnitCostValue] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setAction((prevState) => ({
      ...prevState,
      parameters: {
        ...prevState.parameters,
        [params]: { ...prevState.parameters[params], [name]: value },
      },
    }));
  };
  const handleUnitsChange = (e) => {
    const { name, value } = e.target;
    setAction((prevState) => ({
      ...prevState,
      parameters: {
        ...prevState.parameters,
        [params]: { ...prevState.parameters[params], [name]: value },
      },
    }));
    setUnitQuantityValue(value);
    setUnitCostValue(value);
  };

  useEffect(() => {
    setNewImpact(action?.parameters || {});
  }, [action?.parameters?.impact]);

  function totalCounter(array, key) {
    let total = 0;
    for (const element of array) {
      total += +element?.[key];
    }
    return total;
  }

  useEffect(() => {
    async function getPatrimoineDataAPI() {
      let data = [];
      for (let energy of energyType) {
        await axios
          .get(
            getSite(
              action.parameters.general.groups[0],
              "energy." + energy + "." + "reference"
            ),
            {
              method: "GET",
              headers: {
                Authorization: `Bearer ${UserService.getToken()}`,
              },
            }
          )
          .then((response) => {
            data.push(response.data.detail?.energy || { [energy]: {} });
          });
      }
      setPatrimoineData(data);
    }
    getPatrimoineDataAPI();

    axios
      .get(getSite(action.parameters.general.groups[0], "tertiarybill"), {
        method: "GET",
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((response) => {
        setTertiaryBillData(response.data.detail?.tertiarybill || {});
      });
  }, []);

  useEffect(() => {
    let refConsumptionSource = actionPlans.reference?.refConsumptionSource;
    if (refConsumptionSource == "patrimoine") {
      getPatrimoineData();
    }
    if (refConsumptionSource == "tertiaryBill") {
      getTertiaryBillData();
    }

    let targetedenergy = action.parameters?.impact?.targetedenergy;

    targetedenergy !== undefined &&
      energyType.map((energy) => {
        if (
          action.parameters?.impact?.targetedenergy.find(
            (target) => target.id == energy
          ) !== -1 &&
          newReference?.reference?.[energy + "refconsumption"]?.value !==
          undefined &&
          action.parameters?.impact?.targetedenergy.find(
            (target) => target.id == energy
          )?.value === undefined
        ) {
          let indexFound = action.parameters?.impact?.targetedenergy.findIndex(
            (target) => target.id == energy
          );

          let energyName = targetedenergyList.find(
            (target) => target.id == energy
          ).name;
          let energyValue =
            newReference?.reference?.[energy + "refconsumption"]?.value;

          targetedenergy[indexFound] = {
            id: energy,
            name: energyName,
            value: energyValue,
          };
        }
        setAction((prevState) => ({
          ...prevState,
          parameters: {
            ...prevState.parameters,
            impact: {
              ...prevState.parameters?.impact,
              targetedenergy,
            },
          },
        }));
      });
  }, [action.parameters?.impact?.targetedenergy?.length]);

  const getPatrimoineData = async (event) => {
    pushPatrimoineInNewReference(patrimoineData);
  };

  const getTertiaryBillData = (event) => {
    pushTertiaryInNewReference(tertiaryBillData);
  };

  function pushPatrimoineInNewReference(arr1) {
    let referenceData = {
      ...newReference,
      reference: { ...newReference?.reference },
    };
    let referenceValue = "";
    let referenceDate = "";

    arr1.map((energy) => {
      let energySelected = Object.keys(energy)[0];
      referenceValue = energy[energySelected]?.reference?.referencefinalenergy;
      referenceDate = energy[energySelected]?.reference?.referenceyear;

      if (
        [
          "electricity",
          "gas",
          "fuel",
          "cold",
          "heat",
          "water",
          "propane",
          "wood",
        ].includes(energySelected)
      ) {
        referenceData.reference[energySelected + "refconsumption"] = {
          value: referenceValue,
          date: referenceDate,
        };
      }
    });

    setNewReference(referenceData);
  }

  function pushTertiaryInNewReference(object1) {
    let referenceData = {
      ...newReference,
      reference: { ...newReference?.reference },
    };
    let startdate = object1?.startdate || "";
    for (const [key, value] of Object.entries(object1)) {
      if (
        [
          "electricityrefconsumption",
          "gasrefconsumption",
          "fuelrefconsumption",
        ].includes(key)
      ) {
        referenceData.reference[key] = { value: value, date: startdate };
      } else if (key === "propanekgrefconsumption") {
        referenceData.reference.propanerefconsumption = {
          value: value,
          date: startdate,
        };
      } else if (key === "heatnetworkrefconsumption") {
        referenceData.reference.heatrefconsumption = {
          value: value,
          date: startdate,
        };
      } else if (key === "coldnetworkrefconsumption") {
        referenceData.reference.coldrefconsumption = {
          value: value,
          date: startdate,
        };
      }
    }

    setNewReference(referenceData);
  }

  const urlPlanAction = getAction(action.id);

  let url = putAction(action.id);

  const handleSubmit = (event) => {
    createActionImpact(event);
  };

  const handleSimulate = (event) => {
    axios
      .post(postActionImpact(action.id), action, {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
        },
      })
      .then((response) => {
        setAction((prevState) => ({
          ...prevState,
          parameters: {
            ...prevState.parameters,
            [params]: {
              ...prevState.parameters.impact,
              savings: response.data.savings,
            },
          },
        }));
      });
  };

  const handleCheckboxChange = (e, key) => {
    let newArray = action.parameters?.impact?.[key] || [];

    if (
      e.props.value.includes("all") &&
      targetedusageList.length !== newArray.length
    ) {
      newArray = targetedusageList;
    } else if (e.props.value.includes("all")) {
      newArray = [];
    } else if (newArray.find((n) => n.id == e.props.value) == undefined) {
      newArray.push({
        name: targetedusageList.find((n) => n.id == e.props.value).name,
        id: e.props.value,
      });
    } else {
      newArray = newArray.filter((x) => {
        return x.id != e.props.value;
      });
    }

    setAction((prevState) => ({
      ...prevState,
      parameters: {
        ...prevState.parameters,
        [params]: {
          ...prevState.parameters.impact,
          [key]: newArray,
        },
      },
    }));
  };

  const createActionImpact = async (event) => {
    axios
      .put(
        url,
        { ...newImpact, impact: { ...newImpact.impact } },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          setNotification("success", "Action modifiée");
          getActionData();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  };

  const getActionData = () => {
    axios
      .get(urlPlanAction, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((response) => {
        setAction(response.data || []);
        setNewImpact(response.data.parameters || {});
      });
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const handleSwitchMode = (mode) => {
    setAction((prevState) => ({
      ...prevState,
      parameters: {
        ...prevState.parameters,
        impact: {
          ...prevState.parameters?.impact,
          mode,
        },
      },
    }));
  };

  return (
    <>
      <GridContainer>
        <GridItem xs={12} sm={12} md={action.parameters?.recommendation ? 9 : 12} lg={action.parameters?.recommendation ? 9 : 12}>
          <SubTitle>Fluides & Usages</SubTitle>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12} lg={12}>
              <div
                style={{
                  border: "0.099rem solid rgba(0, 0, 0, .22)",
                  borderRadius: "0.3rem",
                  padding: "0 0.6rem",
                  margin: "0rem 0.5rem 0rem",
                }}
              >
                <RTTargetFluid />
              </div>
            </GridItem>
          </GridContainer>
          <SubTitle>Périmètre</SubTitle>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12} lg={12}>
              <ButtonGroups
                switchMode={action?.parameters?.impact?.mode || ""}
                handleSwitchMode={handleSwitchMode}
                firstButton={"simple"}
                secondButton={"expert"}
                disabled={!actionplanupdate}
              />
            </GridItem>
          </GridContainer>
          {action.parameters?.impact?.mode == "simple" && (
            <>
              <GridContainer>
                <GridItem xs={12} sm={12} md={6} lg={6}>
                  <IntInput
                    inputTitle={`Quantité d'équipement  ${unitycountTypeData.find((x) => x.id == unitQuantityValue)
                      ?.name || ""
                      }`}
                    intInput={
                      action?.parameters?.[params]?.["equipmentscount"] || ""
                    }
                    handleIntInputChange={handleChange}
                    name="equipmentscount"
                    disabled={!actionplanupdate}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={6} lg={6}>
                  <CustomSelect
                    inputTitle={"Unité(s)"}
                    selectValue={
                      action?.parameters?.[params]?.["equipmentsunit"] || ""
                    }
                    handleSelectValueChange={handleUnitsChange}
                    data={unitycountTypeData}
                    name="equipmentsunit"
                    disabled={!actionplanupdate}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer>
                {
                  (action?.parameters?.[params]?.["equipmentsunit"] &&
                    action?.parameters?.[params]?.["equipmentsunit"] !== 'equipmentsunit') &&
                  <GridItem xs={12} sm={12} md={6} lg={6}>
                    <IntInput
                      //inputTitle={actionVar[params]["surface"]}
                      inputTitle={`${unityTypeData.find((x) => x.id == unitCostValue)?.name || ""
                        }`}
                      intInput={action?.parameters?.[params]?.["surface"] || ""}
                      handleIntInputChange={handleChange}
                      name="surface"
                      disabled={!actionplanupdate}
                    />
                  </GridItem>
                }
                <GridItem xs={12} sm={12} md={6} lg={6}>
                  <IntInput
                    inputTitle={`Coût unitaire ${unitcostData.find((x) => x.id == unitCostValue)?.name || ""
                      }`}
                    intInput={action?.parameters?.[params]?.["unitcost"] || ""}
                    handleIntInputChange={handleChange}
                    name="unitcost"
                    disabled={!actionplanupdate}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12} sm={12} md={6} lg={6}>
                  <IntInput
                    inputTitle={actionVar.impact.deperdition}
                    intInput={
                      action?.parameters?.[params]?.["deperdition"] || ""
                    }
                    handleIntInputChange={handleChange}
                    name="deperdition"
                    disabled={!actionplanupdate}
                  />
                </GridItem>
              </GridContainer>
              <SubTitle>Impacts</SubTitle>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12} lg={12}>
                  <CustomSelect
                    inputTitle={actionVar[params].savingstype}
                    selectValue={
                      action?.parameters?.[params]?.["savingstype"] || ""
                    }
                    handleSelectValueChange={handleChange}
                    data={savingstypeData}
                    name="savingstype"
                    disabled={!actionplanupdate}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12} lg={12}>
                  <div
                    style={{
                      border: "0.099rem solid rgba(0, 0, 0, .22)",
                      borderRadius: "0.3rem",
                      padding: "0 0.6rem",
                      margin: "1rem 0.5rem 0rem",
                    }}
                  >
                    <RTSimpleSavings />
                  </div>
                </GridItem>
              </GridContainer>
              {actionplanupdate && (
                <GridContainer style={{ marginTop: "15px", marginLeft: "8px" }}>
                  <GridItem xs={12} sm={12} md={12} lg={12}>
                    <EditButton handleSubmit={handleSubmit}>Modifier</EditButton>
                  </GridItem>
                </GridContainer>
              )}
            </>
          )}
          {action.parameters?.impact?.mode == "expert" && (
            <>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12} lg={12}>
                  <div
                    style={{
                      border: "0.099rem solid rgba(0, 0, 0, .22)",
                      borderRadius: "0.3rem",
                      padding: "0 0.6rem",
                      margin: "1rem 0.5rem 0rem",
                    }}
                  >
                    <RTEquipments />
                  </div>
                </GridItem>
              </GridContainer>
              <SubTitle>Impacts</SubTitle>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12} lg={12}>
                  <CustomSelect
                    inputTitle={actionVar[params].savingstype}
                    selectValue={
                      action?.parameters?.[params]?.["savingstype"] || ""
                    }
                    handleSelectValueChange={handleChange}
                    data={savingstypeData}
                    name="savingstype"
                    disabled={!actionplanupdate}
                  />
                </GridItem>

                <GridItem xs={12} sm={12} md={12} lg={12}>
                  <CustomSelect
                    inputTitle={actionVar[params].savingscalculation}
                    selectValue={
                      action?.parameters?.[params]?.["savingscalculation"] || ""
                    }
                    handleSelectValueChange={handleChange}
                    data={savingscalculationData}
                    name="savingscalculation"
                    disabled={!actionplanupdate}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={12} lg={12}>
                  <div
                    style={{
                      border: "0.099rem solid rgba(0, 0, 0, .22)",
                      borderRadius: "0.3rem",
                      padding: "0 0.6rem",
                      margin: "1rem 0.5rem 0rem",
                    }}
                  >
                    <RTExpertSavings />
                  </div>
                </GridItem>
              </GridContainer>

              {actionplanupdate && (
                <GridContainer>
                  <GridItem
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    style={{ marginLeft: "8px", marginTop: "15px" }}
                  >
                    <EditButton handleSubmit={handleSubmit}>Modifier</EditButton>
                  </GridItem>
                </GridContainer>
              )}
            </>
          )}
        </GridItem>
        {action.parameters?.recommendation &&
          <GridItem xs={12} sm={12} md={3} lg={3}>
            <SubTitle style={{ marginLeft: "-15px" }}>Préconisation</SubTitle>
            <RecommendationArea>
              {action.parameters?.recommendation.split("\n").map((i) => {
                if (!i)
                  return <p><br /></p>;
                else
                  return <p>{i}</p>;
              })}
            </RecommendationArea>
          </GridItem>
        }
      </GridContainer>
    </>
  );
}
